/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], search: string, key: string): any[] {
    if (!items) return [];
    
    if (!search) return items;

    search = search.toLowerCase();
    
    return items.filter((it) => {
      return `${it[key]}`.toLowerCase().includes(search);
    });
  }
}
